import { useAxleQuery } from '@/fetching/apiHelpers';
import { useTrackAppConfigValues } from '@/utils/datadogSessionAttributes';
import { z } from 'zod';

import { type AppConfig, appConfigSchema } from './appConfig.schema';

export type { AppConfig };

export const useAppConfig = (): AppConfig => {
    const appConfig = useAxleQuery({
        path: '/app-config',
        suspense: true,
        responseSchema: z.object({ app_config: appConfigSchema }),
    }).data.app_config;

    useTrackAppConfigValues(appConfig);

    return appConfig;
};
